import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { catchError, tap } from 'rxjs/operators';
import { FrontierRequest, FrontierSummary, PremiumRequest } from '../../../domain/frontier.domain';
import { Offer } from '../../../domain/offer.domain';
import { SystemUser } from '../../../domain/user.model';
import { GenericService } from './generic.service';

@Injectable()
export class FrontierService extends GenericService {
    constructor(private store: Store,
                private http: HttpClient) {
        super(store);
    }

    create(request: FrontierRequest) {
        return this.http.post<SystemUser>(`/api/secured/frontier`, request)
            .pipe(catchError(this.errorsMain), tap(this.cleanMain));
    }

    update(offerId: number, request: FrontierRequest) {
        return this.http.put<SystemUser>(`/api/secured/frontier/${offerId}`, request)
            .pipe(catchError(this.errorsMain), tap(this.cleanMain));
    }

    issue(offerId: number, request: FrontierSummary) {
        return this.http.put<SystemUser>(`/api/secured/frontier/${offerId}/issue`, request)
            .pipe(catchError(this.errorsMain), tap(this.cleanMain));
    }
}
